import { render, staticRenderFns } from "./HealthCheck60.vue?vue&type=template&id=5f7a86bf&scoped=true&"
import script from "./HealthCheck60.vue?vue&type=script&lang=js&"
export * from "./HealthCheck60.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck60.vue?vue&type=style&index=0&id=5f7a86bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a86bf",
  null
  
)

export default component.exports